/**
 * TextArea — Multi-line text input element
 *
 * Variants:
 *   - error: true/false (red border)
 */
import { styled, TextArea as TamaguiTextArea, type GetProps } from 'tamagui'

const TextAreaBase = styled(TamaguiTextArea, {
  name: 'TextArea',
  bg: '$backgroundInput',
  br: '$lg',
  bw: 2,
  bc: '$borderColor',
  borderStyle: 'solid',
  color: '$color',
  px: '$md',
  py: '$md',
  fontSize: 16,
  minHeight: 100,
  placeholderTextColor: '$colorMuted',
  focusStyle: {
    bc: '$borderColorFocus',
    bw: 2,
  },
})

type TextAreaBaseProps = GetProps<typeof TextAreaBase>

interface TextAreaProps extends TextAreaBaseProps {
  error?: boolean
}

export const TextArea = TextAreaBase.styleable<TextAreaProps>(
  ({ error, ...props }, ref) => {
    return (
      <TextAreaBase
        ref={ref}
        {...(error
          ? {
              bc: '$colorError',
              focusStyle: { bc: '$colorError', bw: 2 },
            }
          : {})}
        {...props}
      />
    )
  },
)
